import { createElement, type ElementType, type ReactNode } from 'react'
import './learning-lesson-shell.css'

type LessonShellElement = ElementType

function joinClassNames(...classNames: Array<string | undefined>) {
  return classNames.filter(Boolean).join(' ')
}

export function LearningLessonShell({
  children,
  className,
}: {
  readonly children: ReactNode
  readonly className?: string
}) {
  return (
    <div
      className={joinClassNames('learningLessonShell', className)}
      data-learning-lesson-shell="true"
    >
      {children}
    </div>
  )
}

export function LearningLessonShellHeader({
  as = 'header',
  children,
  className,
}: {
  readonly as?: LessonShellElement
  readonly children: ReactNode
  readonly className?: string
}) {
  return createElement(
    as,
    {
      className: joinClassNames('learningLessonShellHeader', className),
      'data-learning-shell-part': 'header',
    },
    children,
  )
}

export function LearningLessonShellContent({
  as = 'div',
  children,
  className,
  pageWrapClassName,
  viewportClassName,
}: {
  readonly as?: LessonShellElement
  readonly children: ReactNode
  readonly className?: string
  readonly pageWrapClassName?: string
  readonly viewportClassName?: string
}) {
  return createElement(
    as,
    {
      className: joinClassNames('learningLessonShellContent', className),
      'data-learning-shell-part': 'content',
    },
    <div
      className={joinClassNames('learningLessonShellPageWrap', pageWrapClassName)}
      data-learning-shell-part="page-wrap"
    >
      <div
        className={joinClassNames('learningLessonShellViewport', viewportClassName)}
        data-learning-shell-part="viewport"
      >
        {children}
      </div>
    </div>,
  )
}

export function LearningLessonShellFooter({
  children,
  className,
}: {
  readonly children: ReactNode
  readonly className?: string
}) {
  return (
    <div
      className={joinClassNames('learningLessonShellFooter', className)}
      data-learning-shell-part="footer"
    >
      {children}
    </div>
  )
}
